import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import PrismicVue from 'prismic-vue';
import linkResolver from './link-resolver';
// serializer for prismic slices
import htmlSerializer from './helpers/html-serializer';
import Prism from 'prismjs'

// add our css
require('../node_modules/prismjs/themes/prism.css')
require('./sass/css/site.scss')

Vue.config.productionTip = false

// prismic access token
const accessToken = 'MC5Ybmx4bEJBQUFCNEFjOWlL.Ue-_ve-_ve-_vRPvv73vv73vv706FCZhZe-_vQ_vv73vv70877-9Tu-_ve-_vR91Je-_ve-_vWjvv73vv73vv73vv70';

// add prismic to vue
Vue.use(PrismicVue, {
  endpoint: window.prismic.endpoint,
  linkResolver,
  htmlSerializer: htmlSerializer,
  apiOptions: { accessToken }
});

// Highlight some code
Vue.filter('highlight', (code, lang = 'javascript') => {
  return Prism.highlight(code, Prism.languages[lang], lang)
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});

new Vue({
  router,
  vuetify,
  // Define our global state
  // TODO: move this to a store pattern https://vuejs.org/v2/guide/state-management.html
  // data: {
  //   userPaid: false,
  //   userAdmin: true,
  //   userId: null,
  // },
  render: h => h(App)
}).$mount('#app')
